import { Brand } from "@/types/general";

type Props = {
  brand: Brand;
};

const Stone = () => (
  <svg
    height="10"
    viewBox="0 0 91 24"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="logo-stone"
  >
    <g clipPath="url(#clip0_83074_137719)">
      <path
        d="M4.71128 17.0376C4.90716 18.798 6.28109 19.8927 8.32304 19.8927C10.0111 19.8927 11.1882 19.0715 11.1882 17.9758C11.1882 13.9468 0.549757 17.8976 0.549757 9.60479C0.549757 6.1236 3.57203 3.65888 7.61529 3.65888C12.3654 3.65888 15.5845 6.20187 15.7803 10.0743H11.0302C10.7946 8.39222 9.26363 7.49269 7.77236 7.49269C6.28109 7.49269 5.18157 8.15744 5.18157 9.4096C5.18157 13.4386 16.0159 8.86178 16.0159 17.7806C16.0159 21.5362 12.9539 24 8.32212 24C3.6903 24 0.19588 21.3005 0 17.0376H4.71128Z"
        fill="#000714"
        fillOpacity="0.6435"
      ></path>
      <path
        d="M91 16.998C90.2146 21.2618 86.4467 24 81.5784 24C74.8658 24 71.4111 18.7584 71.4111 13.7903C71.4111 8.82219 74.4731 3.65888 81.1857 3.65888C87.8983 3.65888 90.9603 8.78352 90.9603 13.2812C90.9603 14.0242 90.9215 14.6107 90.8817 15.0415H76.6712C77.0639 17.8184 78.8305 19.5401 81.5784 19.5401C83.7765 19.5401 85.2289 18.6793 85.6604 16.9971H90.9991L91 16.998ZM76.7497 11.6H85.5034C85.3463 9.4096 83.8153 7.64921 81.1857 7.64921C78.7122 7.64921 77.221 8.86178 76.7497 11.6Z"
        fill="#000714"
        fillOpacity="0.6435"
      ></path>
      <path
        d="M60.4086 3.6598C53.5676 3.6598 51.1052 8.10496 51.1052 12.2619V23.6879H56.6009V9.50259C56.6009 8.95385 57.0472 8.50915 57.5979 8.50915H63.2202C63.7709 8.50915 64.2171 8.95385 64.2171 9.50259V23.6879H69.7129V12.2619C69.7129 8.10496 67.2496 3.6598 60.4086 3.6598Z"
        fill="#000714"
        fillOpacity="0.6435"
      ></path>
      <path
        d="M28.5356 3.97284H23.2358V0H17.7798V16.5285C17.7798 21.1053 20.7235 23.687 25.2777 23.687H28.5356V19.1101L24.2457 19.0862C23.695 19.0862 23.2487 18.6415 23.2487 18.0928L23.2358 8.50915H28.5356V3.97284Z"
        fill="#000714"
        fillOpacity="0.6435"
      ></path>
      <g clipPath="url(#clip1_83074_137719)">
        <path
          d="M39.4 20.3294L33.7624 14.6915C33.3848 14.3139 33.3818 13.7057 33.7504 13.3228L29.599 12.0075C29.4129 12.9301 29.3518 13.8986 29.4393 14.8943C29.8681 19.7807 33.8597 23.6721 38.7549 23.9797C41.5224 24.1538 44.0646 23.1995 45.9707 21.5353C46.0566 21.4607 45.9647 21.325 45.8645 21.3786C45.2298 21.7207 44.3533 22.0049 43.1956 22.0049C40.9738 22.0049 39.4 20.3294 39.4 20.3294Z"
          fill="#000714"
          fillOpacity="0.6435"
        ></path>
        <path
          d="M39.4 4C36.8812 4 34.5809 4.93311 32.8226 6.4707C32.7374 6.54532 32.8309 6.67948 32.9304 6.62597C33.5657 6.28302 34.4438 5.99661 35.6045 5.99661C37.9349 5.99661 39.4 7.67062 39.4 7.67062L45.0377 13.3085C45.419 13.6898 45.4198 14.3079 45.0392 14.69L49.1513 16.2133C49.3126 15.501 49.4 14.7609 49.4 14.0004C49.4 8.47711 44.9231 4 39.4 4Z"
          fill="#000714"
          fillOpacity="0.6435"
        ></path>
        <path
          d="M45.0402 14.6899C45.0402 14.6899 45.714 13.7704 46.3621 13.9294C49.3038 14.6507 49.3912 13.5496 49.3912 13.5496C49.3912 13.5496 49.8058 20.8916 44.3113 20.8916C41.9809 20.8916 40.5157 19.2175 40.5157 19.2175L45.0402 14.6899Z"
          fill="url(#paint0_linear_83074_137719)"
        ></path>
        <path
          d="M33.7607 13.3115C33.7607 13.3115 33.0869 14.231 32.4387 14.072C29.497 13.3507 29.4096 14.4519 29.4096 14.4519C29.4096 14.4519 28.9951 7.10986 34.4895 7.10986C36.8199 7.10986 38.2851 8.78388 38.2851 8.78388L33.7607 13.3115Z"
          fill="url(#paint1_linear_83074_137719)"
        ></path>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_83074_137719"
        x1="42.3713"
        y1="21.0604"
        x2="47.3768"
        y2="16.0551"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="currentColor" stopOpacity="0"></stop>
        <stop offset="0.15" stopColor="currentColor" stopOpacity="0.15"></stop>
        <stop offset="0.51" stopColor="currentColor" stopOpacity="0.61"></stop>
        <stop offset="0.8" stopColor="currentColor" stopOpacity="0.9"></stop>
        <stop offset="1" stopColor="currentColor"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_83074_137719"
        x1="36.428"
        y1="6.94103"
        x2="31.4225"
        y2="11.9463"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.05" stopColor="currentColor" stopOpacity="0"></stop>
        <stop offset="0.15" stopColor="currentColor" stopOpacity="0.15"></stop>
        <stop offset="0.51" stopColor="currentColor" stopOpacity="0.61"></stop>
        <stop offset="0.8" stopColor="currentColor" stopOpacity="0.9"></stop>
        <stop offset="1" stopColor="currentColor"></stop>
      </linearGradient>
      <clipPath id="clip0_83074_137719">
        <rect width="91" height="24" fill="white"></rect>
      </clipPath>
      <clipPath id="clip1_83074_137719">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(29.4 4)"
        ></rect>
      </clipPath>
    </defs>
  </svg>
);

const Ton = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="12"
    viewBox="0 0 21 14"
    fill="none"
    data-testid="logo-ton"
  >
    <path
      d="M19.3654 9.39373C19.9338 9.39373 20.3945 8.93308 20.3945 8.36468V5.56326C20.3945 3.32527 18.8125 1.63708 16.7148 1.63708C14.6171 1.63708 13.0352 3.32476 13.0352 5.56326V8.36468C13.0352 8.93308 13.4958 9.39373 14.0642 9.39373C14.6326 9.39373 15.0933 8.93308 15.0933 8.36468V5.56326C15.0933 4.3603 15.7148 3.61297 16.7148 3.61297C17.7148 3.61297 18.3364 4.3603 18.3364 5.56326V8.36468C18.3364 8.93308 18.797 9.39373 19.3654 9.39373Z"
      fill="#000714"
      fillOpacity="0.6435"
    />
    <path
      d="M8.29542 1.63708C6.13054 1.63708 4.36914 3.39844 4.36914 5.56326C4.36914 7.72812 6.13054 9.48948 8.29542 9.48948C10.4603 9.48948 12.2217 7.72812 12.2217 5.56326C12.2217 3.39844 10.4603 1.63708 8.29542 1.63708ZM8.29542 7.51359C7.22024 7.51359 6.34507 6.63892 6.34507 5.56326C6.34507 4.48812 7.21973 3.61297 8.29542 3.61297C9.37059 3.61297 10.2458 4.48764 10.2458 5.56326C10.2458 6.63845 9.3711 7.51359 8.29542 7.51359Z"
      fill="#000714"
      fillOpacity="0.6435"
    />
    <path
      d="M7.82996 10.8352C8.18235 10.4628 8.79388 10.4252 9.18333 10.7585C10.1473 11.5846 11.0936 12.0307 12.5061 12.0307C13.9186 12.0307 14.865 11.5841 15.8289 10.7585C16.2184 10.4252 16.8299 10.4628 17.1823 10.8352C17.5747 11.2503 17.5422 11.8959 17.1061 12.2648C15.7742 13.39 14.3733 14 12.5066 14C10.64 14 9.23899 13.39 7.90717 12.2648C7.47057 11.8959 7.43799 11.2508 7.83097 10.8352H7.82996Z"
      fill="#000714"
      fillOpacity="0.6435"
    />
    <path
      d="M0 6.17875C0 8.00025 1.29172 9.26786 3.02102 9.38614C3.02102 9.38614 3.25461 9.39266 3.29972 9.39167C3.8215 9.37915 4.24507 8.96961 4.24507 8.44834C4.24507 7.92755 3.82201 7.50552 3.29972 7.50552C2.57542 7.50552 2.05612 6.92659 2.03357 6.22437V3.61291H3.21049C3.72077 3.61291 4.1348 3.19991 4.1348 2.69062C4.1348 2.18137 3.72077 1.76837 3.21049 1.76837H2.03357V1.0145C2.03357 0.454119 1.57843 4.15714e-07 1.01653 4.15714e-07C0.455135 -0.000501812 0 0.454119 0 1.0145V3.10315V6.17875Z"
      fill="#000714"
      fillOpacity="0.6435"
    />
  </svg>
);

const logos = {
  stone: Stone,
  ton: Ton,
};

export const Logo = ({ brand }: Props) => {
  const LogoComponent = logos[brand];

  return <LogoComponent />;
};
